module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-dialog', {
    attrs: {
      "width": "600px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Create payout record")])]), _vm._v(" "), _c('v-card-text', [_c('v-row', [_c('v-col', [_c('v-combobox', {
    attrs: {
      "items": _vm.campaigns,
      "search-input": _vm.search,
      "error-messages": _vm.selectedCampaignErrors,
      "hide-details": "auto",
      "item-text": "name",
      "label": "Campaign Name",
      "dense": "",
      "small-chips": "",
      "outlined": ""
    },
    on: {
      "update:searchInput": function($event) {
        _vm.search = $event
      },
      "update:search-input": function($event) {
        _vm.search = $event
      },
      "input": function($event) {
        return _vm.$v.payout.campaign.$touch()
      },
      "blur": function($event) {
        return _vm.$v.payout.campaign.$touch()
      },
      "change": function($event) {
        return _vm.changeCampaign()
      }
    },
    scopedSlots: _vm._u([{
      key: "no-data",
      fn: function() {
        return [_c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v("\n                      No results matching \"\n                      "), _c('strong', [_vm._v(_vm._s(_vm.search))]), _vm._v("\". Press "), _c('kbd', [_vm._v("enter")]), _vm._v(" to create a new one\n                    ")])], 1)], 1)]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.payout.campaign),
      callback: function($$v) {
        _vm.$set(_vm.payout, "campaign", $$v)
      },
      expression: "payout.campaign"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "sm": "12"
    }
  }, [_c('v-combobox', {
    attrs: {
      "items": _vm.influencers,
      "item-text": "handle",
      "hide-details": "auto",
      "label": "Influencers",
      "prefix": "@",
      "dense": "",
      "outlined": "",
      "error-messages": _vm.handleErrors
    },
    on: {
      "input": function($event) {
        return _vm.$v.payout.handle.$touch()
      },
      "blur": function($event) {
        return _vm.$v.payout.handle.$touch()
      },
      "change": function($event) {
        return _vm.changeInfluencer()
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('social-handle-view', {
          attrs: {
            "divClassName": "d-inline",
            "isTikTok": item.platform === 'tiktok',
            "isInstagram": !item.platform || item.platform === 'instagram',
            "isYoutube": item.platform === 'youtube',
            "isFacebook": item.platform === 'facebook',
            "isXiaohongshu": item.platform === 'xiaohongshu',
            "tiktokHandle": item.handle,
            "instagramHandle": item.handle,
            "youtubeHandle": item.handle,
            "facebookHandle": item.handle,
            "xiaohongshuHandle": item.handle
          }
        })]
      }
    }]),
    model: {
      value: (_vm.payout.handle),
      callback: function($$v) {
        _vm.$set(_vm.payout, "handle", $$v)
      },
      expression: "payout.handle"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Swift Code",
      "hide-details": "auto",
      "error-messages": _vm.bankSwiftCodeErrors,
      "placeholder": "RABONL2U",
      "outlined": "",
      "dense": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.payout.bankSwiftCode.$touch()
      },
      "blur": function($event) {
        return _vm.$v.payout.bankSwiftCode.$touch()
      }
    },
    model: {
      value: (_vm.payout.bankSwiftCode),
      callback: function($$v) {
        _vm.$set(_vm.payout, "bankSwiftCode", $$v)
      },
      expression: "payout.bankSwiftCode"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Bank A/C No.",
      "placeholder": "Bank A/C No.(omit dashes)",
      "error-messages": _vm.bankNoErrors,
      "hide-details": "auto",
      "outlined": "",
      "dense": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.payout.bankAccountNo.$touch()
      },
      "blur": function($event) {
        return _vm.$v.payout.bankAccountNo.$touch()
      }
    },
    model: {
      value: (_vm.payout.bankAccountNo),
      callback: function($$v) {
        _vm.$set(_vm.payout, "bankAccountNo", $$v)
      },
      expression: "payout.bankAccountNo"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Payee Name",
      "placeholder": "Payee Name.",
      "error-messages": _vm.receivingNameErrors,
      "hide-details": "auto",
      "outlined": "",
      "dense": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.payout.receivingName.$touch()
      },
      "blur": function($event) {
        return _vm.$v.payout.receivingName.$touch()
      }
    },
    model: {
      value: (_vm.payout.receivingName),
      callback: function($$v) {
        _vm.$set(_vm.payout, "receivingName", $$v)
      },
      expression: "payout.receivingName"
    }
  }), _vm._v(" "), (_vm.payout.handle) ? _c('caption', {
    staticClass: "font-weight-bold",
    staticStyle: {
      "min-width": "200px"
    }
  }, [_vm._v("Paired Amount: " + _vm._s(_vm.utilsFunc.currencySym(_vm.payout.currency)) + " " + _vm._s(_vm.payout.handle.amount || 0))]) : _vm._e(), _vm._v(" "), (_vm.payout.completedCurrency && _vm.payout.completedCurrency === 'SGD') ? _c('caption', {
    staticClass: "font-weight-bold pb-0",
    staticStyle: {
      "min-width": "200px"
    }
  }, [_vm._v("\n              Paid Amount: S$ " + _vm._s(_vm.payout.paidAmt || 0)), _c('br'), _vm._v(" "), (_vm.payout.currency !== 'SGD') ? _c('span', [_vm._v("(Est: " + _vm._s(_vm.utilsFunc.currencySym(_vm.payout.currency)) + " " + _vm._s(_vm.payout.convertedEstAmt) + ")")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.payout.completedCurrency && _vm.payout.completedCurrency !== 'SGD') ? _c('caption', {
    staticClass: "font-weight-bold pb-0 pt-0",
    staticStyle: {
      "min-width": "200px"
    }
  }, [_vm._v("\n              Paid Amount: " + _vm._s(_vm.utilsFunc.currencySym(_vm.payout.completedCurrency)) + " " + _vm._s(_vm.payout.paidAmt || 0) + " "), _c('br'), _vm._v(" "), (_vm.payout.actualAmount) ? _c('span', [_vm._v("(Actual: S$ " + _vm._s(_vm.payout.actualAmount) + ")")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("(Est: " + _vm._s(_vm.utilsFunc.currencySym(_vm.payout.completedCurrency)) + " " + _vm._s(_vm.payout.convertedEstAmt) + ")")])]) : _vm._e(), _vm._v(" "), (_vm.payout.handle && !_vm.payout.completedCurrency) ? _c('caption', {
    staticClass: "font-weight-bold pb-0",
    staticStyle: {
      "min-width": "200px"
    }
  }, [_vm._v("Paid Amount: 0")]) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Amount",
      "type": "number",
      "placeholder": "300",
      "prefix": _vm.payout.currency,
      "outlined": "",
      "dense": "",
      "hide-details": "auto"
    },
    on: {
      "input": function($event) {
        return _vm.checkUnpaidAmount()
      },
      "blur": function($event) {
        return _vm.$v.payout.amount.$touch()
      }
    },
    model: {
      value: (_vm.payout.amount),
      callback: function($$v) {
        _vm.$set(_vm.payout, "amount", $$v)
      },
      expression: "payout.amount"
    }
  }), _vm._v(" "), (_vm.unPaidAmtErr) ? _c('span', {
    staticClass: "text-danger ma-0 pt-1"
  }, [_vm._v("Amount entered is exceeding than remain amount.")]) : _vm._e(), _vm._v(" "), (_vm.payout.processingAmt !== '') ? _c('caption', {
    staticClass: "font-weight-bold pb-0",
    staticStyle: {
      "min-width": "200px"
    }
  }, [_vm._v("Processing Amount: " + _vm._s(_vm.utilsFunc.currencySym(_vm.payout.currency)) + " " + _vm._s(_vm.payout.processingAmt || 0))]) : _vm._e(), _vm._v(" "), (_vm.payout.remainAmt !== '') ? _c('caption', {
    staticClass: "font-weight-bold pb-0",
    staticStyle: {
      "min-width": "200px"
    }
  }, [_vm._v("Remaining Amount: " + _vm._s(_vm.utilsFunc.currencySym(_vm.payout.currency)) + " " + _vm._s(_vm.payout.remainAmt || 0))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('v-text-field', _vm._g({
    attrs: {
      "dense": "",
      "outlined": "",
      "label": "Live Date (DD/MM/YYYY)",
      "hide-details": "auto",
      "error-messages": _vm.liveDateErrors
    },
    on: {
      "blur": function($event) {
        return _vm.$v.payout.live_date.$touch()
      },
      "input": _vm.changeLiveDate,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.changeLiveDate.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.payout.live_date),
      callback: function($$v) {
        _vm.$set(_vm.payout, "live_date", $$v)
      },
      expression: "payout.live_date"
    }
  }, _vm.on)), _vm._v(" "), (_vm.isInvalidLiveDate) ? _c('span', {
    staticClass: "text-danger ma-0 pt-1"
  }, [_vm._v("Invalid Live Date")]) : _vm._e(), _vm._v(" "), (!_vm.isInvalidLiveDate && !_vm.payout.live_date) ? _c('span', {
    staticClass: "text-danger ma-0 pt-1"
  }, [_vm._v("Required")]) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('v-text-field', _vm._g({
    attrs: {
      "dense": "",
      "outlined": "",
      "label": "Due Date (DD/MM/YYYY)",
      "hide-details": "auto",
      "error-messages": _vm.dueDateErrors
    },
    on: {
      "blur": function($event) {
        return _vm.$v.payout.due_date.$touch()
      }
    },
    model: {
      value: (_vm.payout.due_date),
      callback: function($$v) {
        _vm.$set(_vm.payout, "due_date", $$v)
      },
      expression: "payout.due_date"
    }
  }, _vm.on)), _vm._v(" "), (!_vm.payout.due_date) ? _c('span', {
    staticClass: "text-danger ma-0 pt-1"
  }, [_vm._v("Required")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-row', [(_vm.isBankRef) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Bank Reference",
      "placeholder": "BK19010043050112",
      "persistent-hint": "",
      "hide-details": "auto",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: (_vm.payout.bank_reference),
      callback: function($$v) {
        _vm.$set(_vm.payout, "bank_reference", $$v)
      },
      expression: "payout.bank_reference"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ma-0 pt-1",
    staticStyle: {
      "color": "#fb8c00 !important"
    }
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "color": "warning"
    }
  }, [_vm._v("mdi-alert-circle-outline")]), _vm._v(" For Finance Only\n            ")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isPaymentDate) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('v-text-field', _vm._g({
    attrs: {
      "dense": "",
      "outlined": "",
      "label": "Payment Date (DD/MM/YYYY)",
      "hide-details": "auto"
    },
    model: {
      value: (_vm.payout.payment_date),
      callback: function($$v) {
        _vm.$set(_vm.payout, "payment_date", $$v)
      },
      expression: "payout.payment_date"
    }
  }, _vm.on)), _vm._v(" "), _c('p', {
    staticClass: "ma-0 pt-1",
    staticStyle: {
      "color": "#fb8c00 !important"
    }
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "color": "warning"
    }
  }, [_vm._v("mdi-alert-circle-outline")]), _vm._v(" For Finance Only\n            ")], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "sm": "12"
    }
  }, [_c('v-checkbox', {
    attrs: {
      "hide-details": "",
      "label": "Include GST 9%"
    },
    model: {
      value: (_vm.payout.chkGST),
      callback: function($$v) {
        _vm.$set(_vm.payout, "chkGST", $$v)
      },
      expression: "payout.chkGST"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "sm": "12"
    }
  }, [_c('v-textarea', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "hide-details": "",
      "label": "Remarks",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: (_vm.payout.remarks),
      callback: function($$v) {
        _vm.$set(_vm.payout, "remarks", $$v)
      },
      expression: "payout.remarks"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "sm": "12"
    }
  }, [_c('custom-file-upload', {
    attrs: {
      "refresh": _vm.fileUploadRefresh
    },
    on: {
      "setMedias": _vm.updateInvoices
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red darken-1",
      "text": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "disabled": _vm.disableSavePayout,
      "text": ""
    },
    on: {
      "click": _vm.savePayout
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9e5fc734"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Finance/CreatePaymentConsolidateModal.vue
// module id = 2249
// module chunks = 0